import React, { useState, useEffect } from 'react';
import { Header, Landing, Dashboard, ToastProvider, loadSettings, applyTheme } from './components';
import { UserInfo } from './types';
import { getUserInfo } from './api';

const App: React.FC = () => {
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
  const [loading, setLoading] = useState(true);

  // Apply theme on initial load
  useEffect(() => {
    const settings = loadSettings();
    applyTheme(settings.theme);
  }, []);

  const fetchUserInfo = async () => {
    try {
      const info = await getUserInfo();
      setUserInfo(info);
    } catch (error) {
      console.error('Failed to fetch user info:', error);
      setUserInfo({
        authenticated: false,
        connections: {
          twitch: { connected: false },
          youtube: { connected: false },
        },
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserInfo();
  }, []);

  const handleLogout = () => {
    setUserInfo({
      authenticated: false,
      connections: {
        twitch: { connected: false },
        youtube: { connected: false },
      },
    });
  };

  if (loading) {
    return (
      <div className="loading" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="spinner" />
      </div>
    );
  }

  const isAuthenticated = userInfo?.authenticated;
  const hasAnyConnection = 
    userInfo?.connections.twitch.connected || 
    userInfo?.connections.youtube.connected;

  return (
    <ToastProvider>
      <Header userInfo={userInfo} onLogout={handleLogout} />
      {isAuthenticated && hasAnyConnection ? (
        <Dashboard userInfo={userInfo!} />
      ) : (
        <Landing />
      )}
    </ToastProvider>
  );
};

export default App;
